<template>
  <v-card>
    <v-layout>
      <v-app-bar title="ONEPLAN Админка"></v-app-bar>

      <Navigation />

      <v-main style="min-height: 100vh">
        <v-container fluid>
          <v-card>
            <v-card-title>
              <v-row justify="end" class="mb-4 ml-0 mr-0 mt-0" dense>
                <v-col cols="1">Баннеры</v-col>
                <v-col cols="11"
                  ><router-link to="/banners/new">Создать</router-link></v-col
                >
              </v-row>
            </v-card-title>
            <v-card-text>
              <BannerList />
            </v-card-text>
          </v-card>
        </v-container>
      </v-main>
    </v-layout>
  </v-card>
</template>
<script>
import Navigation from "@/components/Navigation";
import BannerList from "@/components/Banner/BannerList";
export default {
  components: {
    Navigation,
    BannerList,
  },
};
</script>
